import { MainEntryState } from './definitions';

import { mockLandingPageLabels } from '../../constants/main-entry-data';

export class MainEntryFactory
{
	public static build(): MainEntryState 
	{
		return { ...mockLandingPageLabels };
	}
}
